import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Label } from '@/components/ui/label';
import { UserCheck } from 'lucide-react';

export function useFuncionarios() {
  const [funcionarios, setFuncionarios] = useState([]);
  const [loadingFunc, setLoadingFunc] = useState(true);

  useEffect(() => {
    const fetchFuncionarios = async () => {
      try {
        const res = await api.get('/rh/funcionarios?status=ativo');
        setFuncionarios(res.data || []);
      } catch (e) {
        console.error('Erro ao carregar funcionários:', e);
      } finally {
        setLoadingFunc(false);
      }
    };
    fetchFuncionarios();
  }, []);

  return { funcionarios, loadingFunc };
}

export function FuncionarioSelect({ value, onChange, label = "Funcionário Responsável", required = true, funcionarios = [] }) {
  return (
    <div>
      <Label className="flex items-center gap-1.5 mb-1">
        <UserCheck className="w-4 h-4 text-blue-600" />
        {label} {required && <span className="text-red-500">*</span>}
      </Label>
      <select
        value={value || ''}
        onChange={(e) => {
          const id = e.target.value;
          const func = funcionarios.find(f => f.id === id);
          onChange(id, func?.nome || '');
        }}
        className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        required={required}
        data-testid="funcionario-select"
      >
        <option value="">Selecione o funcionário...</option>
        {funcionarios.map(f => (
          <option key={f.id} value={f.id}>
            {f.nome} {f.cargo ? `(${f.cargo})` : ''}
          </option>
        ))}
      </select>
      {funcionarios.length === 0 && (
        <p className="text-xs text-amber-600 mt-1">Nenhum funcionário ativo cadastrado no RH. Cadastre funcionários primeiro.</p>
      )}
    </div>
  );
}
